import { useState } from 'react';
import { useToast } from '@chakra-ui/react';
import baseService from '../services/base';

export function useEvidenceDownload() {
  const toast = useToast();
  const [isLoadingEvidence, setLoadingEvidence] = useState(false);

  const downloadEvidence = async ({ surveyId, companyGroupId, formName }) => {
    setLoadingEvidence(true);
    try {
      const response = await baseService.get(
        `/downloads?survey=${surveyId}&group=${companyGroupId}`,
        {
          responseType: 'blob',
          timeout: 30000,
        }
      );

      if (!response?.data) {
        throw new Error('No data received from server');
      }

      const blob = new Blob([response.data], { type: 'application/zip' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${formName}_evidence.zip`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast({
        title: 'Download das evidências iniciado com sucesso',
        status: 'success',
      });
    } catch (error) {
      console.error('Evidence download error:', error);
      let errorMessage = 'Não foi possível processar os arquivos anexados.';

      if (error?.response?.status === 404) {
        errorMessage = 'Arquivos não encontrados.';
      } else if (error?.response?.status === 413) {
        errorMessage = 'Arquivos muito grandes para download.';
      } else if (error?.code === 'ECONNABORTED') {
        errorMessage = 'Tempo limite excedido. Tente novamente.';
      }

      toast({
        title: 'Erro ao fazer o download das evidências',
        description: errorMessage,
        status: 'error',
      });
    } finally {
      setLoadingEvidence(false);
    }
  };

  return {
    downloadEvidence,
    isLoadingEvidence,
  };
}